export default {
  namespaced: true,
  state: {
    idle: false,
  },
  actions: {
    idleStart(context) {
      context.commit("setIdle", true);
    },
    idleStop(context) {
      context.commit("setIdle", false);
    },
  },
  mutations: {
    setIdle(state, idle) {
      state.idle = idle;
    },
  },
};
